import { colors } from 'ui/theme';

export const defaultColorPalette = [
  colors.salmon50,
  colors.mustard50,
  colors.cyan50,
  colors.purple90,
  colors.green50,
  colors.cyan20,
  colors.red20,
  colors.cyan100,
  colors.purple50,
  colors.red50,
  colors.salmon20,
  colors.mustard10,
  colors.cyan20,
  colors.purple10,
  colors.green20,
  colors.cyan10,
  colors.red10,
  colors.salmon10,
  colors.green10,
  colors.purple100,
];
